"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column = function Column() {
  return null;
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ../~/rc-table/es/Column.js
// module id = 1045
// module chunks = 1